// src/components/LoadingIndicator.tsx
import React from 'react';

interface LoadingIndicatorProps {
  /** 全ページを覆うかどうか */
  isFullPage?: boolean;
  /** サイズ(直径) */
  size?: number; // px
  /** 色(省略時はデフォルト) */
  color?: string;
}

// スピナー回転アニメーションの keyframes
const spinnerKeyframes = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  isFullPage = false,
  size = 40,
  color,
}) => {
  // 全画面表示時は fixed オーバーレイ、
  // 部分表示時は相対配置のコンテナ
  const overlayStyle: React.CSSProperties = isFullPage
    ? {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9998,
    }
    : {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    };

  const computedColor = color || '#1DB954';
  const spinnerBorder = size / 8;

  const spinnerStyle: React.CSSProperties = {
    border: `${spinnerBorder}px solid #f3f3f3`,
    borderTop: `${spinnerBorder}px solid ${computedColor}`,
    borderRadius: '50%',
    width: size,
    height: size,
    animation: 'spin 1s linear infinite',
  };

  return (
    <>
      <style>{spinnerKeyframes}</style>
      <div style={overlayStyle}>
        <div style={spinnerStyle} />
      </div>
    </>
  );
};

export default LoadingIndicator;
